"use strict";

import $ from "jquery";

let searchRecommendation = $('.js-form-item-search-api-fulltext');


searchRecommendation.append('<div class="search-buttons"><div class="secondary-search-button"><input data-drupal-selector="edit-submit-ipl-database-search-2" type="submit" id="edit-submit-ipl-database-search--2" value="SEARCH" class="js-form-submit form-submit au-btn"></div><div id=btn-filters-search class="btn-filters-recommendation filters-view"><p>FILTERS</p></div></div>');
searchRecommendation.prepend('<img src="/themes/custom/ia/assets/images/search-icon-grey.svg" alt="">');

$('.btn-filters-recommendation').click(function() {
  $('.search-filter-set').toggle('hidden');
});

$('.js-form-item-search-api-fulltext-db').append('<div class="search-buttons"><div class="secondary-search-button"><input data-drupal-selector="edit-submit-ipl-database-search-2" type="submit" id="edit-submit-ipl-database-search--2" value="SEARCH" class="js-form-submit form-submit au-btn"></div><div id=btn-filters-search class="btn-filters filters-view"><p>FILTERS</p></div></div>');
$('.js-form-item-search-api-fulltext-db').prepend('<img src="/themes/custom/ia/assets/images/search-icon-grey.svg" alt="">');
//$('.view-display-id-ipl_view_block_map_facet').before('<div class="filters-list"><div class="filters-list-title">ADVANCED SEARCH</div></div>');
$('#edit-actions--3 #edit-submit-ipl-database-search--2').after('<a href="/search-infrastructure-priority-list"><input type="button" id="reset-all" class="au-btn" value="Clear All"></a>');
$('#edit-submit-ipl-database-search').after('<a href="/search-infrastructure-priority-list"><input type="button" id="reset-all" class="au-btn" value="Clear All"></a>');


$('.btn-filters').click(function() {
  var filtersBlock =  $('#filters-search');
  $('#views-exposed-form-ipl-database-search-ipl-map-db-search #edit-actions--2').before(filtersBlock);
  $('#views-exposed-form-ipl-database-search-ipl-map-db-search #edit-actions--3').before(filtersBlock);
  $('#filters-search').toggle('hidden');
});


$('.path-search-infrastructure-priority-list .facets-widget-checkbox__selector').on('click', function(e) {
  e.preventDefault();
});
